import {mergeDeepObject} from "./_util";
import {Popover, Tooltip} from "../../index.esm";
import Scrollbar from "smooth-scrollbar";

const VegasUI = {
	boot: () => {
		// Popovers
		let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
		popoverTriggerList.map(function (popoverTriggerEl) {
			return new Popover(popoverTriggerEl, {
				html: true,
				container: 'body',
			})
		});

		// Tooltip
		let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl, {
				trigger: 'hover'
			})
		})
	},

	fancybox: (target = "[data-fancybox]", params = {}) => {
		fbx.Fancybox.bind(target, mergeDeepObject(params, {
			Image: {
				zoom: false,
			}}));
	},

	scrollbar: function ($selectors = [], arg = {}) {
		let scrollbars = [];

		if ($selectors.length) {
			scrollbars = $selectors;
		} else {
			scrollbars = document.querySelectorAll('[data-scrollbar]');
		}

		if (scrollbars.length) {
			for (let bar of scrollbars) {
				let option = mergeDeepObject({
					damping: parseInt(bar.dataset.damping) || .1,
					thumbMinSize: parseInt(bar.dataset.thumbMinSize) || 20,
					renderByPixels: bar.dataset.renderByPixels !== 'false',
					alwaysShowTracks: bar.dataset.alwaysShowTracks || false,
				}, arg);

				Scrollbar.init(bar, option);
			}
		}
	},
}

function onReady() {
	// Boot
	VegasUI.boot();

	// Fancybox
	VegasUI.fancybox();

	// ScrollBar
	VegasUI.scrollbar();
}

document.addEventListener("DOMContentLoaded", onReady);

export default VegasUI;
